import { carrierUtils } from "@flights/web-api-utils-universal";
import { getFeaturesToRender } from "../../../branded-fares/utils/features.js";
import { createTrackingUtils } from "../index.js";
import { SELLABLE_FEATURES_AIRLINES, NON_INCLUDED_FEATURES_AIRLINES } from "@flights/ancillaries-universal";
import { SEAT_FEATURES } from "@flights/branded-fares";
const utils = createTrackingUtils({
    name: "flights_apex_web_filter_branded_fare_features_on_backend",
    defaultStage: 1,
    stages: {
        main: 1,
        search_results: 2,
        branded_fares_page: 3,
        sellable_features_carrier: 4,
        excluded_features_carrier: 5,
        mileage_accrual_carrier: 6,
        sellable_lounge_access_carrier: 7,
        executive_lounge_access_carrier: 8
    },
    goals: {
        sellable_features_present: 1,
        non_included_features_present: 2,
        sellable_lounge_access_present: 3,
        mileage_accrual_present: 4,
        executive_lounge_access_present: 5
    },
    goalsWithValue: [
        "flights_apex_web_filter_branded_fare_features_on_backend_included_features_count_displayed",
        "flights_apex_web_filter_branded_fare_features_on_backend_sellable_features_count_displayed",
        "flights_apex_web_filter_branded_fare_features_on_backend_non_included_features_count_displayed",
        "flights_apex_web_filter_branded_fare_features_on_backend_seat_features_count_displayed"
    ]
});
const isFeatureVisible = (features, featureName) => features.some((feature) => feature.featureName === featureName);
const hasCarrier = (flightSegments, carrierCodes) => carrierUtils.hasMarketingCarrier(flightSegments, [...carrierCodes]);
export const getDisplayedBrandedFareFeatures = ({ brandedFareInfo, sellableFeaturesRequiredByAirline, excludedFeaturesRequiredByAirline, isPreCheckAndPay = true }) => {
    const { includedFeatures, nonIncludedFeatures } = getFeaturesToRender(brandedFareInfo, {
        includeSellableFeatures: sellableFeaturesRequiredByAirline,
        includeExcludedFeatures: excludedFeaturesRequiredByAirline,
        isPreCheckAndPay
    });
    return {
        displayedIncludedFeatures: includedFeatures.filter((feature) => feature.availability === "INCLUDED"),
        displayedSellableFeatures: includedFeatures.filter((feature) => feature.availability === "SELLABLE"),
        displayedNonIncludedFeatures: nonIncludedFeatures
    };
};
export const trackBrandedFareFeaturesOnBackendStages = (page, flightSegments) => {
    utils.stages.main();
    if (page === "search_results") {
        utils.stages.search_results();
    }
    else {
        utils.stages.branded_fares_page();
    }
    if (hasCarrier(flightSegments, SELLABLE_FEATURES_AIRLINES)) {
        utils.stages.sellable_features_carrier();
    }
    if (hasCarrier(flightSegments, NON_INCLUDED_FEATURES_AIRLINES)) {
        utils.stages.excluded_features_carrier();
    }
    if (hasCarrier(flightSegments, ["AA"])) {
        utils.stages.mileage_accrual_carrier();
    }
    if (hasCarrier(flightSegments, ["EY"])) {
        utils.stages.sellable_lounge_access_carrier();
    }
    if (hasCarrier(flightSegments, ["UA"])) {
        utils.stages.executive_lounge_access_carrier();
    }
};
export const trackBrandedFareFeaturesOnBackendGoals = (params) => {
    const { displayedIncludedFeatures, displayedSellableFeatures, displayedNonIncludedFeatures } = getDisplayedBrandedFareFeatures(params);
    const displayedFeatures = [
        ...displayedIncludedFeatures,
        ...displayedSellableFeatures,
        ...displayedNonIncludedFeatures
    ];
    const displayedSeatFeatures = displayedFeatures.filter((feature) => SEAT_FEATURES.includes(feature.featureName));
    if (displayedSellableFeatures.length > 0) {
        utils.goals.sellable_features_present();
    }
    if (displayedNonIncludedFeatures.length > 0) {
        utils.goals.non_included_features_present();
    }
    if (isFeatureVisible(displayedSellableFeatures, "LOUNGE_ACCESS")) {
        utils.goals.sellable_lounge_access_present();
    }
    if (isFeatureVisible(displayedFeatures, "MILEAGE_ACCRUAL")) {
        utils.goals.mileage_accrual_present();
    }
    if (isFeatureVisible(displayedFeatures, "EXECUTIVE_LOUNGE")) {
        utils.goals.executive_lounge_access_present();
    }
    utils.goalsWithValue.flights_apex_web_filter_branded_fare_features_on_backend_included_features_count_displayed(displayedIncludedFeatures.length);
    utils.goalsWithValue.flights_apex_web_filter_branded_fare_features_on_backend_sellable_features_count_displayed(displayedSellableFeatures.length);
    utils.goalsWithValue.flights_apex_web_filter_branded_fare_features_on_backend_non_included_features_count_displayed(displayedNonIncludedFeatures.length);
    utils.goalsWithValue.flights_apex_web_filter_branded_fare_features_on_backend_seat_features_count_displayed(displayedSeatFeatures.length);
};
export default utils;
